import { useMemo, useState } from 'react';

import { Highcharts } from '@/shared/lib/highcharts';
import type { TemplateChartSeries } from '@/shared/types/charts';

import type HighchartsType from 'highcharts';
import type { ChartsBlockTabType } from '@/features/markets/types';

const indicatorTitles = new Map([
  ['bb', 'Bollinger Bands'],
  ['linearRegression', 'Linear Regression'],
  ['linearRegressionAngle', 'Linear Regression Angle'],
  ['linearRegressionIntercept', 'Linear Regression Intercept'],
  ['linearRegressionSlope', 'Linear Regression Slope'],
  ['apo', 'Absolute Price'],
  ['atr', 'Average True Range'],
  ['natr', 'NATR']
]);

type SeriesTypeConstructor = {
  prototype: HighchartsType.Series & { nameBase?: string };
};

type HighchartsWithSeriesTypes = typeof Highcharts & {
  seriesTypes: Record<string, SeriesTypeConstructor>;
};

(function (H: HighchartsWithSeriesTypes) {
  const { seriesTypes } = H;
  for (const [key, value] of Object.entries(seriesTypes)) {
    const title = indicatorTitles.get(key);
    if (title) {
      value.prototype.nameBase = title;
    }
  }
})(Highcharts as unknown as HighchartsWithSeriesTypes);

const useMarketsChart = <T>(tab: ChartsBlockTabType<T>) => {
  const [activeTab, setActiveTab] = useState(0);

  const metadata = tab.metadata;

  const templateChartSeries: TemplateChartSeries[] = useMemo(() => {
    return tab.series;
  }, [activeTab, tab]);

  return {
    activeTab,
    setActiveTab,
    templateChartSeries,
    metadata
  };
};

export default useMarketsChart;
